import React, { useEffect, useState } from 'react';

/**
 * AuthCallbackPage — lands here from crm-api's /api/auth/entra/callback with the CRM staff JWT in
 * the URL fragment (`#token=…`). Fragments are never sent to a server, so the token reaches only
 * this page. Store it where AuthProvider and getJwt() read it, then hard-reload into the app.
 */
export function AuthCallbackPage(): React.ReactElement {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token');
    if (token === null || token.split('.').length !== 3) {
      setFailed(true);
      return;
    }
    localStorage.setItem('crm_dev_token', token);
    // Drop the fragment from history before leaving so the token is not in the back stack.
    window.history.replaceState(null, '', '/auth/callback');
    window.location.replace('/dashboard');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-info-soft px-4">
      <p role="status" className="text-sm text-ink-soft">
        {failed ? 'Sign-in did not complete. ' : 'Completing sign-in…'}
        {failed && <a className="text-info underline" href="/login">Back to sign in</a>}
      </p>
    </div>
  );
}
